import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { TextField, Checkbox, FormControlLabel, Grid, Button } from '@material-ui/core';
import * as validatorActions from '../../../components/validator/store/actions';
import * as courseActions from '../../course/store/actions';
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { SketchPicker } from 'react-color';

const styles = theme => ({
    root: {
        width: '90%',
    },
    button: {
        marginRight: theme.spacing.unit,
    },
    backButton: {
        marginRight: theme.spacing.unit,
    },
    completed: {
        display: 'inline-block',
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
    },
});

class ScaffoldForm extends React.Component {

    handleChange = field_name => event => {
        let value = ''

        if (field_name === 'Color') {
            value = event.hex
        }
        else {
            if (event.target.type === 'checkbox') {
                value = event.target.checked ? 1 : 0;
            }
            else {
                value = event.target.value;
            }
        }

        const update_data = {
            [field_name]: value
        }

        const validator = {
            field_name, value
        }

        this.props.runValidator(validator)
        this.props.updateCourseScaffold(update_data);
    }

    handleBlur = (field_name) => (event) => {
        const { updateCourseScaffold } = this.props;
        let new_value = event.target.value;

        if (isNaN(new_value)) {
            new_value = Number(0);
        } else {
            new_value = Math.abs(Number(new_value));
        }

        const update_data = {
            [field_name]: new_value
        }
        updateCourseScaffold(update_data);
    }

    render() {
        const { classes, courseScaffold, validator } = this.props
        const errors = validator.map(v => v.error);

        let disableSave = errors.includes(true)
        if (errors.includes(null)) {
            disableSave = true
        }

        const daySelections = this.props.courseScaffold.days.map(day => {
            return (
                <Grid item xs={12} key={day.id}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                className={classes.textField}
                                checked={this.props.courseScaffold.days.filter(d => d.name === day.name)[0].selected}
                                onChange={() => this.props.handleDaySelect(day.id)}
                                color="primary"
                            />
                        }
                        label={day.name}
                    />
                </Grid>
            )
        })

        const majorSelection = this.props.availableMajors.map(major => {
            return (
                <Grid item xs={12} key={major.major_id}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                className={classes.textField}
                                checked={this.props.courseScaffold.majors.indexOf(major.major_id - 1).selected}
                                onChange={() => this.props.handleMajorSelect(major.major_id)}
                                color="primary"
                            />
                        }
                        label={major.MajorName}
                    />
                </Grid>
            )
        })
        return (

            <div className="p-24">
                <Grid container spacing={8}>
                    <Grid item xs={3}>
                        <h2>Course Builder</h2>
                        <form style={styles.insidePaper} className={classes.container} noValidate autoComplete="off">
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="CourseName"
                                    label="Course Name"
                                    className={classes.textField}
                                    value={courseScaffold.CourseName}
                                    onChange={this.handleChange('CourseName')}
                                    margin="normal"
                                    variant="outlined"
                                    error={validator.filter(v => v.field_name === 'CourseName')[0].error}
                                    helperText={validator.filter(v => v.field_name === 'CourseName')[0].error_msg}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="CourseDescription"
                                    label="Course Description"
                                    className={classes.textField}
                                    value={courseScaffold.CourseDescription}
                                    onChange={this.handleChange('CourseDescription')}
                                    margin="normal"
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="CourseSizeLimit"
                                    label="Course Size Limit"
                                    className={classes.textField}
                                    value={courseScaffold.CourseSizeLimit}
                                    onChange={this.handleChange('CourseSizeLimit')}
                                    onBlur={this.handleBlur('CourseSizeLimit')}
                                    margin="normal"
                                    variant="outlined"
                                    type='number'
                                    inputProps={{
                                        min: 0,
                                        step: 1
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="Weeks"
                                    label="Weeks"
                                    className={classes.textField}
                                    value={courseScaffold.Weeks}
                                    onChange={this.handleChange('Weeks')}
                                    onBlur={this.handleBlur('Weeks')}
                                    margin="normal"
                                    variant="outlined"
                                    type='number'
                                    inputProps={{
                                        min: 0,
                                        step: 1
                                    }}
                                />
                            </Grid>
                        </form>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        className={classes.textField}
                                        checked={this.props.courseScaffold.Unscheduled === 1}
                                        onChange={this.handleChange('Unscheduled')}
                                        color="primary"
                                    />
                                }
                                label={'Unscheduled'}
                            />
                        </Grid>

                        <Button variant="contained" onClick={() => this.props.updateStep('scaffold')} disabled={disableSave} color="primary">Submit</Button>
                    </Grid>
                    <Grid item xs={3}>
                        <Grid item xs={12}>
                            {this.props.courseScaffold.Unscheduled === 1 ? null :
                                <div>
                                    <h2>Days of Week</h2>
                                    {daySelections}
                                </div>

                            }
                        </Grid>
                    </Grid>

                    <Grid item xs={3}>
                        <Grid item xs={12}>
                            <h2>Majors</h2>
                            {majorSelection}
                        </Grid>
                    </Grid>
                    <Grid item xs={3}>
                        <Grid item xs={12}>
                            <SketchPicker
                                color={courseScaffold.Color}
                                onChangeComplete={this.handleChange('Color')}
                                disableAlpha={true}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </div >
        )
    }


}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateCourseScaffold: courseActions.updateCourseScaffold,
        handleDaySelect: courseActions.handleDaySelect,
        handleMajorSelect: courseActions.handleMajorSelect,
        updateStep: courseActions.updateStep,
        runValidator: validatorActions.runValidator
    }, dispatch);
}

function mapStateToProps({ validator, courseApp }) {
    return {
        courseScaffold: courseApp.courseBuilder.courseScaffold,
        availableMajors: courseApp.courseBuilder.availableMajors,
        validator: validator.list
    }
}
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ScaffoldForm)));



// WEBPACK FOOTER //
// src/main/content/course/builderComponents/ScaffoldForm.js